import { AI_HOST } from '@/constant';
import { i18n } from '@/i18n';
import { RepoType } from '@/utils/types';
const { t } = i18n.global;

export enum AI_HUB {
  AI_MODELS = 'ai-models',
  AI_DATASETS = 'ai-datasets',
  AI_ZONE = 'ai-zone',
  AI_SPACE = 'ai-space',
  AI_INVITE = 'ai-invite'
}

export const AI_Hub_P_Type = 'aiHub';

export const aiThemeMenuId = 'ai-theme';
/**
* https://test-ai.gitcode.net/   在ai.gitcode.com域名下，头部菜单的配置
*/
const headerMenus = [
  {
    label: t('aihub.model'),
    icon: 'gt-model_default',
    activeIcon: 'gt-model_red',
    url: `${AI_HOST}/models`,
    repoType: RepoType.model
  },
  {
    label: t('aihub.dataSet'),
    icon: 'gt-dataset_default',
    activeIcon: 'gt-dataset_red',
    url: `${AI_HOST}/datasets`,
    repoType: RepoType.dataset
  },
  {
    label: 'Spaces',
    icon: 'gt-space_default',
    activeIcon: 'gt-space_red',
    url: `${AI_HOST}/space`,
    repoType: RepoType.spaces
  },
  {
    label: '专区',
    id: aiThemeMenuId,
    icon: 'gt-a-Property1Default7',
    activeIcon: 'gt-a-Property1red6',
    url: `${AI_HOST}/theme`
  },
  {
    label: '大赛',
    icon: 'gt-a-plane-GrowthCenter1',
    activeIcon: 'gt-a-plane-GrowthCenter-1',
    url: `${AI_HOST}/competition`
  }
];

export {
  headerMenus
};
export enum PUBLISH_STATUS {
  PRE_PUBLISH = 'pre_publish',
  PUBLISH_FAIL = 'publish_fail',
  PUBLISH = 'publish',
}
export const PUBLISH_STATUS_MAP = {
  pre_publish: 'aihub.prepublishChecking',
  publish_fail: 'aihub.prepublishTag',
  publish: '发布成功'
};
export const PUBLISH_ERROR_LOG_MAP = {
  readme_content_audit: '请完善模型的 README 信息，避免内容过少或使用默认模板',
  must_files_audit: '请上传模型文件或相关配置，确保模型可用',
  file_name_audit: '请更换名称，避免使用 “test” 或 “测试”',
  must_have_lfs_file_audit: '请上传模型文件或相关配置，确保模型可用',
  lfs_import_status_audit: 'LFS 文件导入可能需要较长时间，导入完成后文件才会对外公开',
  dataset_must_files_audit: '您的数据集内容不完整，仅包含基础文件或空 Python 文件。请添加有效数据文件或代码，确保数据集可用'
};
export const repoType:Record<string, any> = {
  0: '代码仓',
  1: '模型仓',
  2: '数据集',
  3: 'Space'
};
